import type { DashboardItem } from '../types/dashboard.types';
import { AWAITING_AGREEMENT_REASON, AWAITING_AGREEMENT_STATUS } from './dashboardStatus';
import { isThirdPartyRow, thirdPartyAgreementPath } from './thirdPartyAgreements';

export const NO_QUOTE_LINK_REASON = 'No quote reference is available for this record.';
export const NO_AGREEMENT_LINK_REASON = 'No agreement reference is available for this record.';
export const NO_THIRD_PARTY_LINK_REASON = 'This Third Party agreement has no registration to open it by.';

// `quote_id` is nullable and dashboard:sync-quotes nulls it; `record_id` is NOT NULL
// and holds the same quote uuid, so it is the fallback rather than a second source.
export const resolveQuoteContinuationId = (row: DashboardItem): string | undefined =>
    row.quote_id || row.record_id || undefined;

export const resolveAgreementTarget = (row: DashboardItem): string | undefined =>
    isThirdPartyRow(row)
        ? thirdPartyAgreementPath(row)
        : row.agreement_id
          ? `/agreements/${row.agreement_id}`
          : row.plan_id
            ? `/agreements/quote/${row.plan_id}`
            : undefined;

const thirdPartyNoLinkReason = (row: DashboardItem): string | undefined =>
    thirdPartyAgreementPath(row)
        ? undefined
        : row.reference?.trim()
          ? NO_THIRD_PARTY_LINK_REASON
          : NO_AGREEMENT_LINK_REASON;

const quoteNoLinkReason = (row: DashboardItem): string | undefined =>
    resolveQuoteContinuationId(row) ? undefined : NO_QUOTE_LINK_REASON;

export const resolveNoLinkReason = (row: DashboardItem): string | undefined => {
    if (isThirdPartyRow(row)) return thirdPartyNoLinkReason(row);
    if (row.record_type === 'quote') return quoteNoLinkReason(row);
    return resolveAgreementTarget(row) ? undefined : NO_AGREEMENT_LINK_REASON;
};

export const resolveDisabledReason = (row: DashboardItem): string | undefined => {
    if (isThirdPartyRow(row)) return thirdPartyNoLinkReason(row);
    return row.status === AWAITING_AGREEMENT_STATUS ? AWAITING_AGREEMENT_REASON : resolveNoLinkReason(row);
};
